import React, { useEffect, useState } from 'react';
import { EVENTS } from 'constants/config';
import useEventListener from 'components/shared/hooks/useEventListener';

const INCOMPLETE_STEPS_SELECTOR = '.JourneyContentStep';
const COLLAPSED_COMPLETED_STEP_INDICATOR_CLASS_NAME =
  '.JourneyContentStepIndicator';
const COLLAPSED_COMPLETED_STEP_CLASS_NAME = '.JourneyContentCollapsed-step';

const TIMEOUT_DELAY = 50;

function getAbsolutePosition(elem) {
  const containerRect = document
    .querySelector('.JourneyContentsList')
    .getBoundingClientRect();
  const elemRect = elem.getBoundingClientRect();
  const offset = elemRect.top - containerRect.top;
  return {
    top: offset,
  };
}

const StepIndicatorConnector = ({ isExpanded }) => {
  const [dashTop, setDashTop] = useState(0);
  const [dashBottom, setDashBottom] = useState(0);
  const [solidTop, setSolidTop] = useState(0);
  const [solidBottom, setSolidBottom] = useState(0);

  let timerId = null;

  const setPosition = () => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      const allCompletedNodes = document.querySelectorAll(
        COLLAPSED_COMPLETED_STEP_CLASS_NAME,
      );
      const allIncompleteNodes = document.querySelectorAll(
        INCOMPLETE_STEPS_SELECTOR,
      );

      const completedNodeIndicator = document.querySelector(
        COLLAPSED_COMPLETED_STEP_INDICATOR_CLASS_NAME,
      );
      const lastCompletedNode = allCompletedNodes[allCompletedNodes.length - 1];
      const firstIncompleteNode = allIncompleteNodes[0];
      const lastIncompleteNode =
        allIncompleteNodes[allIncompleteNodes.length - 1];

      const allStepsIncomplete = !!lastIncompleteNode && !!firstIncompleteNode;
      const allStepsCompleted = completedNodeIndicator && !!lastCompletedNode;
      const stepsPartiallyCompleted =
        completedNodeIndicator &&
        !!firstIncompleteNode &&
        !!firstIncompleteNode &&
        !!lastIncompleteNode;

      if (stepsPartiallyCompleted) {
        setDashTop(getAbsolutePosition(completedNodeIndicator).top);
        setDashBottom(getAbsolutePosition(firstIncompleteNode).top);
        setSolidTop(getAbsolutePosition(firstIncompleteNode).top);
        setSolidBottom(getAbsolutePosition(lastIncompleteNode).top);
      } else if (allStepsIncomplete) {
        setSolidTop(getAbsolutePosition(firstIncompleteNode).top);
        setSolidBottom(getAbsolutePosition(lastIncompleteNode).top);
      } else if (allStepsCompleted) {
        setDashTop(getAbsolutePosition(completedNodeIndicator).top);
        setDashBottom(getAbsolutePosition(lastCompletedNode).top);
      } else {
        setDashTop(0);
        setDashBottom(0);
        setSolidTop(0);
        setSolidBottom(0);
      }
    }, TIMEOUT_DELAY);
  };

  useEffect(() => {
    window.addEventListener('resize', setPosition);
    global.pubsub.subscribe(EVENTS.SET_STEP_CONNECTOR_POSITION, setPosition);

    setPosition();

    return () => {
      global.pubsub.unsubscribe(
        EVENTS.SET_STEP_CONNECTOR_POSITION,
        setPosition,
      );
      window.removeEventListener('resize', setPosition);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPosition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpanded]);

  useEventListener('resize', setPosition);
  const dashHeight = dashBottom - dashTop;
  const solidHeight = solidBottom - solidTop;

  return (
    <div>
      <div
        className="JourneyStepsConnector JourneyStepsConnector--dashed"
        style={{ top: dashTop, height: dashHeight }}
      />
      <div
        className="JourneyStepsConnector"
        style={{ top: solidTop, height: solidHeight }}
      />
    </div>
  );
};

export default StepIndicatorConnector;
